import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMarketExprtChargeCodesPanel extends Layout {
    labelChargeCodes: Label;
    panel1: Panel;
    sourceMarketrateExprt: DataSource;
    textboxCarrierFuelSurcharge: Textbox;
    textboxCarrierLoadUnload: Textbox;
    textboxCarrierStopCharges: Textbox;
    textboxCustomerLoadUnload: Textbox;
    textboxCustomerStopCharges: Textbox;
}
